export { Body1Stronger, body1StrongerClassNames } from './components/presets/Body1Stronger/index';
